export default "__VITE_ASSET__C8cE9Vit__"